// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, [4146,8383], () => (__webpack_require__("./globalStyles.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
